<script>
import TranscriptSummaryCard from '@modules/crm/components/transcript-summary-card/transcript-summary-card.vue'
import TranscriptSummaryItem from '@modules/crm/components/transcript-summary-item/transcript-summary-item.vue'
import TranscriptStateFeedback from '@modules/crm/components/transcript-state-feedback/transcript-state-feedback.vue'

export default {
  name: 'DetailTabAcoes',
  components: {
    TranscriptSummaryCard,
    TranscriptSummaryItem,
    TranscriptStateFeedback,
  },
  props: {
    actions: { type: Array, default: () => [] },
    aiStatus: { type: String, default: '' },
  },
  computed: {
    // Sem ações: distingue "aguardando IA" de "vazio" e já retorna as props do
    // TranscriptStateFeedback (state + ícone + mensagem).
    acoesFeedback() {
      const processing = ['queued', 'processing', 'pending'].includes(
        this.aiStatus
      )
      return {
        state: processing ? 'processing' : 'empty',
        icon: 'mdi-clipboard-check-outline',
        message: processing
          ? 'Gerando ações com IA…'
          : 'Nenhuma ação gerada para esta reunião.',
      }
    },
  },
  methods: {
    actionLabel(action) {
      if (!action) return ''
      return (
        action.texto ||
        action.label ||
        action.title ||
        action.descricao ||
        action.text ||
        ''
      )
    },
    actionDetail(action) {
      if (!action) return ''
      return action.detail || action.description || action.detalhe || ''
    },
    actionOwner(action) {
      return (action && (action.owner || action.responsavel)) || ''
    },
    actionDue(action) {
      return (action && (action.due || action.prazo)) || ''
    },
    actionTag(action) {
      const owner = this.actionOwner(action)
      const due = this.actionDue(action)
      if (owner && due) return owner + ' · ' + due
      return owner || due || ''
    },
  },
}
</script>

<template>
  <div>
    <TranscriptSummaryCard v-if="actions.length" title="Ações geradas">
      <div class="d-flex flex-column az-gap-small">
        <TranscriptSummaryItem
          v-for="(action, i) in actions"
          :key="i"
          icon="check-circle"
          icon-color="success"
          :text="actionLabel(action)"
        >
          <template v-if="actionTag(action)" v-slot:right>
            <v-chip x-small color="#E8EAF1" text-color="#5B5B5B">
              {{ actionTag(action) }}
            </v-chip>
          </template>
        </TranscriptSummaryItem>
      </div>
    </TranscriptSummaryCard>

    <TranscriptStateFeedback v-else v-bind="acoesFeedback" />
  </div>
</template>
